import React, { useEffect, useState, useCallback } from 'react'
import { Link, useLocation } from 'react-router-dom'

const NAV_LINKS = [
  { to: '/',            label: 'Home' },
  { to: '/about',       label: 'About' },
  { to: '/programs',    label: 'Programs' },
  { to: '/impact',      label: 'Impact' },
  { to: '/get-involved',label: 'Get Involved' },
  { to: '/contact',     label: 'Contact' },
]

export default function Navbar() {
  const [solid, setSolid]       = useState(false)
  const [drawerOpen, setDrawer] = useState(false)
  const location = useLocation()

  // Solid on scroll
  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 48)
    window.addEventListener('scroll', onScroll, { passive: true })
    onScroll()
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  // Close drawer on route change
  useEffect(() => { setDrawer(false) }, [location.pathname])

  // Lock body scroll when drawer open
  useEffect(() => {
    document.body.style.overflow = drawerOpen ? 'hidden' : ''
    return () => { document.body.style.overflow = '' }
  }, [drawerOpen])

  const isActive = useCallback(
    (to) => (to === '/' ? location.pathname === '/' : location.pathname.startsWith(to)),
    [location.pathname]
  )

  // Show dark text when scrolled solid; white text on transparent (over hero)
  const onDark = !solid

  return (
    <>
      <nav className={`sisdi-navbar${solid ? ' nav-solid' : ''}${onDark ? ' nav-on-dark' : ''}`}>
        <div className="nav-inner">
          {/* Logo */}
          <Link className="nav-logo" to="/" aria-label="SISDI Home">
            <img src="/images/logo.png" alt="SISDI Logo" />
          </Link>

          {/* Desktop links */}
          <ul className="nav-links">
            {NAV_LINKS.map(({ to, label }) => (
              <li key={to}>
                <Link to={to} className={isActive(to) ? 'active' : ''}>
                  {label}
                </Link>
              </li>
            ))}
          </ul>

          {/* Desktop donate CTA */}
          <div className="nav-donate">
            <Link to="/donate" className="btn btn-accent btn-sm">
              <i className="bi bi-heart-fill" style={{ fontSize: '0.75rem' }}></i>
              Donate Now
            </Link>
          </div>

          {/* Hamburger */}
          <button
            className={`nav-hamburger${drawerOpen ? ' open' : ''}`}
            onClick={() => setDrawer(v => !v)}
            aria-label={drawerOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={drawerOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>

      {/* Mobile drawer */}
      <div className={`nav-drawer${drawerOpen ? ' open' : ''}`} role="dialog" aria-modal="true">
        <button
          className="nav-drawer-close"
          onClick={() => setDrawer(false)}
          aria-label="Close menu"
        >
          <i className="bi bi-x-lg"></i>
        </button>

        <Link className="nav-logo" to="/" style={{ marginTop: '1rem' }}>
          <img src="/images/logo.png" alt="SISDI Logo" />
        </Link>

        <nav className="drawer-links">
          {NAV_LINKS.map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              className={isActive(to) ? 'active' : ''}
              onClick={() => setDrawer(false)}
            >
              {label}
            </Link>
          ))}
        </nav>

        <div className="drawer-cta">
          <Link to="/donate" className="btn btn-accent btn-lg" onClick={() => setDrawer(false)}>
            <i className="bi bi-heart-fill"></i> Donate Now
          </Link>
        </div>
      </div>
    </>
  )
}
